export const ACTION_ADD_WARRANTY = '/Warranty/addWarranty';